import { render, staticRenderFns } from "./DuplicatesReviewModal.vue?vue&type=template&id=0bddd2d4&scoped=true&"
import script from "./DuplicatesReviewModal.vue?vue&type=script&lang=ts&"
export * from "./DuplicatesReviewModal.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicatesReviewModal.vue?vue&type=style&index=0&id=0bddd2d4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bddd2d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardActions,VCardText,VCardTitle,VIcon,VLazy,VRow,VSpacer,VTooltip})
